<template>
    <div class="kyc-card">
        
        <div>
            <img :src="kyc.image" alt="KYC Document" class="kyc-image"  @click="show = true" />
            <vue-easy-lightbox :visible="show"
                               :imgs="[kyc.image]"
                               @hide="show = false" />
        </div>
        <div class="kyc-info">
            <p><strong class="label">Type:</strong> {{ kyc.type }}</p>
            <p>
                <strong class="label">Status:</strong>
                <span :class="statusClass(kyc.status)">
                    {{ kyc.status }}
                </span>
            </p>
            <p><strong class="label">Date Submitted:</strong> {{ formatDate(kyc.date) }}</p>

            <div v-if="kyc.status === 'Rejected'" class="rejection-message">
                <p><strong>Rejection Message:</strong> {{ kyc.rejectionMessage }}</p>
            </div>
        </div>

        <div v-if="showRejectInput" class="reject-input">
            <textarea v-model="rejectionInput"
                      placeholder="Enter rejection reason..."
                      class="reject-textarea"></textarea>
            <button @click="confirmReject" class="btn btn-reject">
                Submit Rejection
            </button>
            <button @click="cancelReject" class="btn-cancel">
                Cancel
            </button>
        </div>

        <div v-else-if="kyc.status === 'Pending'" class="kyc-actions">
            <button @click="approve" class="btn btn-approve">
                Approve
            </button>
            <button @click="showRejectInput = true" class="btn btn-reject">
                Reject
            </button>
        </div>
    </div>
</template>

<script>
    import VueEasyLightbox from 'vue-easy-lightbox'
    export default {
        name: 'KYCReviewCard',
        components: { VueEasyLightbox },
        props: {
            kyc: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                showRejectInput: false,
                rejectionInput: '',
                show:false
            }
        },
        methods: {
            formatDate(date) {
                const d = new Date(date)
                return d.toLocaleDateString() + ' ' + d.toLocaleTimeString()
            },
            statusClass(status) {
                if (status === 'Approved') return 'status-approved'
                if (status === 'Rejected') return 'status-rejected'
                return 'status-pending'
            },
            approve() {
                this.kyc.status = 'Approved'
                this.kyc.rejectionMessage = ''
            },
            confirmReject() {
                if (!this.rejectionInput.trim()) {
                    alert('Please enter a rejection message.')
                    return
                }
                this.kyc.status = 'Rejected'
                this.kyc.rejectionMessage = this.rejectionInput
                this.showRejectInput = false
                this.rejectionInput = ''
            },
            cancelReject() {
                this.showRejectInput = false
                this.rejectionInput = ''
            }
        }
    }
</script>

<style scoped>
    .kyc-card {
        max-width: 400px;
        margin: 20px auto;
        background: #fff; /* white background */
        border-radius: 12px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        color: #333; /* normal dark text */
    }

    .kyc-image {
        width: 100%;
        height: 200px;
        object-fit: cover;
        border-radius: 8px;
    }

    .kyc-info p {
        margin: 5px 0;
        font-size: 14px;
    }

    .label {
        background: #555;
        color: #fff;
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 12px;
        margin-right: 5px;
    }

    .status-approved {
        color: green;
        font-weight: bold;
    }

    .status-rejected {
        color: red;
        font-weight: bold;
    }

    .status-pending {
        color: orange;
        font-weight: bold;
    }

    .rejection-message {
        background: #ffe5e5;
        padding: 10px;
        border-radius: 8px;
        color: #a00;
        font-size: 14px;
    }

    .reject-input {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .reject-textarea {
        width: 100%;
        padding: 8px;
        min-height: 80px;
        border: 1px solid #ccc;
        border-radius: 8px;
        font-size: 14px;
    }

    .kyc-actions {
        display: flex;
        gap: 10px;
    }

    .btn {
        flex: 1;
        padding: 10px;
        border: none;
        border-radius: 8px;
        color: #fff;
        cursor: pointer;
        font-weight: bold;
        font-size: 14px;
    }

    .btn-approve {
        background: green;
    }

    .btn-reject {
        background: red;
    }

    .btn-cancel {
        background: transparent;
        color: #555;
        font-size: 13px;
        border: none;
        cursor: pointer;
        text-decoration: underline;
    }
</style>
